import AdminLayout from "./Admin";
import NonAuthLayout from "./NonAuth";
import { IRouteConfig } from "@lib/types";
import { NavStyle } from "@lib/constants/AppEnums";
import { AdminSidebarMenuProps } from "./Admin/AdminSidebar";

export type AppLayoutProps = {
  children: React.ReactElement | null;
  routesConfig?: IRouteConfig[];
  menuProps?: AdminSidebarMenuProps;
};

const Layouts: Partial<Record<NavStyle, React.FC<AppLayoutProps>>> = {
  [NavStyle.ADMIN]: AdminLayout,
  [NavStyle.NON_AUTH]: NonAuthLayout,
};
export default Layouts;
